/**
 * `MyWorkSource` over the C3 api. Structurally typed so this module never imports server code.
 */
import type { MyWorkListInput, MyWorkResultView, MyWorkSettingsView, MyWorkSource } from './types';

interface Query<TIn, TOut> {
  query(input: TIn): Promise<TOut>;
}
interface Mutate<TIn, TOut> {
  mutate(input: TIn): Promise<TOut>;
}

export interface MyWorkTrpc {
  myWork: {
    list: Query<MyWorkListInput | undefined, MyWorkResultView>;
    settings: Query<undefined, MyWorkSettingsView>;
    saveSettings: Mutate<Partial<MyWorkSettingsView>, MyWorkSettingsView>;
  };
}

export function createMyWorkSource(trpc: MyWorkTrpc): MyWorkSource {
  return {
    list: (input) => trpc.myWork.list.query(input),
    settings: () => trpc.myWork.settings.query(undefined),
    saveSettings: (patch) => trpc.myWork.saveSettings.mutate(patch),
  };
}
